'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { urlWithParams } from '@marketplace-web/browser/url-util'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import { clickEvent } from '@marketplace-web/help-center-conversation-support/conversation-support-data'
import { TrackingChannel } from '@marketplace-web/help-center/help-center-faq-entry-url-data'
import { useAbTest, useTrackAbTestCallback } from '@marketplace-web/feature-flags/ab-tests-data'

import { TRANSACTION_FAQ_ENTRY_URL } from '../../constants/routes'

type Props = ConversationActionProps

const ReportProblem = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const { transaction } = useConversationContext()

  const { relativeUrl } = useBrowserNavigation()

  const deliveryIssuesAbTest = useAbTest('unified_delivery_issues_complaints_v3')
  const trackExpose = useTrackAbTestCallback()

  const trackReportProblem = () => {
    const targetDetails = {
      transaction_id: transaction?.id,
    }

    track(
      clickEvent({
        target: 'i_have_an_issue',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )

    if (deliveryIssuesAbTest) {
      trackExpose(deliveryIssuesAbTest)
    }
  }

  if (!transaction?.id) return null

  const problemReportUrl = urlWithParams(TRANSACTION_FAQ_ENTRY_URL(transaction?.id), {
    ref_url: relativeUrl,
    ch: TrackingChannel.Conversation,
    related_only: true,
  })

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={problemReportUrl}
      onClick={trackReportProblem}
      testId="conversation-action--report-problem-button"
    />
  )
}

export default ReportProblem
